import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {MealPlanModelService} from "@menu-api";
import {EMPTY, Observable, throwError} from "rxjs";
import {catchError} from "rxjs/operators";
import {getContextKey} from "../api/api-helper";
import {API_CALLS, API_CONTEXT_TOKEN} from "../constants";
import {ErrorService} from "./error.service";

export const API_ERROR_IGNORES = [
    getContextKey(MealPlanModelService.name, API_CALLS.STREAM_APPROVAL_NEEDED),
];

export function errorInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const errorService = inject(ErrorService);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (API_ERROR_IGNORES.includes(req.context.get(API_CONTEXT_TOKEN))) {
                return EMPTY;
            }
            errorService.setError(req.context.get(API_CONTEXT_TOKEN) || error.message);
            return throwError(() => error);
        }),
    );
}
